/**
 * All external / fact-like values live here and ship EMPTY on purpose.
 * The app must render and function with every value blank.
 * Fill each one ONLY with a real, written-approved value from the client.
 */

export const META_PIXEL_ID = '' // Meta Pixel ID provided by the client's ad account
export const LEAD_WEBHOOK_URL = '' // CRM / automation webhook that receives the lead payload (must return CORS headers)
export const CAPI_ENDPOINT = '' // Server endpoint that forwards events to Meta Conversions API
/**
 * Single shared WhatsApp line for Miami Car Queens, in international digits only.
 * Whoever is available answers. Every WhatsApp control on the page opens this number.
 * If it is ever split into one line per Queen, reintroduce a chooser before opening.
 */
export const WHATSAPP_MAIN = '17868371854'
export const INSTAGRAM_URL = '' // Official Instagram profile URL
/**
 * Absolute URL of the share image used by WhatsApp / Meta link previews (1200×630).
 * Empty until an approved photo exists — no og:image tag is rendered while it is blank,
 * which is better than a preview card pointing at a missing file.
 */
export const OG_IMAGE_URL = ''
export const PRIVACY_POLICY_URL = '' // Hosted privacy policy URL
export const TERMS_URL = '' // Hosted terms URL
export const DEALER_DISCLOSURE = '' // Legal disclosure line, rendered in footer only if non-empty

// Fill ONLY with a credential the person has confirmed in writing.
export const GABRIELA_SUBTITLE = ''
export const CHANIRA_SUBTITLE = ''

// Fill ONLY with an address the client has approved for public use.
// The FAQ location answer reads from this and says nothing extra if it is empty.
export const LOCATION_ADDRESS = ''
